module.exports = __webpack_public_path__ + "img/pr-8.804134e4.png";